import { useState } from 'react'

export default function ThrillFillSpillGuide() {
  const [open, setOpen] = useState(false)

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1 text-xs font-body font-bold text-ac-green hover:text-ac-green-dark underline decoration-dotted"
      >
        ❓ What's Thriller/Filler/Spiller?
      </button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40" onClick={() => setOpen(false)}>
          <div className="ac-dialog max-w-md w-full p-6" onClick={e => e.stopPropagation()}>
            <h2 className="font-pixel text-ac-brown text-sm mb-4">The Pro Gardener's Secret 🌿</h2>
            <p className="font-body text-sm text-ac-brown mb-4">
              Every great container has three types of plants working together:
            </p>
            <div className="space-y-3 mb-4">
              <div className="flex gap-3 items-start">
                <span className="text-2xl">🌟</span>
                <div>
                  <p className="font-body font-bold text-ac-brown text-sm">Thriller</p>
                  <p className="font-body text-xs text-ac-brown-light">The tall showstopper in the center or back. Adds height and drama — think tall grasses, cannas, or spiky cordyline.</p>
                </div>
              </div>
              <div className="flex gap-3 items-start">
                <span className="text-2xl">🌸</span>
                <div>
                  <p className="font-body font-bold text-ac-brown text-sm">Filler</p>
                  <p className="font-body text-xs text-ac-brown-light">Mid-height mounding plants that surround the thriller and create fullness — petunias, begonias, and geraniums are classic fillers.</p>
                </div>
              </div>
              <div className="flex gap-3 items-start">
                <span className="text-2xl">✨</span>
                <div>
                  <p className="font-body font-bold text-ac-brown text-sm">Spiller</p>
                  <p className="font-body text-xs text-ac-brown-light">Trailing plants that cascade over the pot edges, softening the look. Sweet potato vine, million bells, and bacopa are perfect spillers.</p>
                </div>
              </div>
            </div>
            <p className="font-body text-xs text-ac-brown-light mb-4 italic">
              Tip: All plants in one container should share similar sun and water needs!
            </p>
            <button className="ac-btn-green w-full" onClick={() => setOpen(false)}>Got it! 🌱</button>
          </div>
        </div>
      )}
    </>
  )
}
